module.exports = __webpack_public_path__ + "static/img/sox5.f793406.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/furnitures/sox5.png
// module id = OhNH
// module chunks = 0